import axios from "axios";

// `/auth` exists only at the unversioned API root, and REACT_APP_API_DOMAIN
// sometimes carries `/api/v1` and sometimes does not, so strip it.
const API_ROOT = (window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN || "").replace(
  /\/api\/v\d+\/?$/,
  ""
);

export type CurrentUserStatus = "active" | "invited";

/** `GET /auth/me`. Only `id` and `email` are guaranteed present. */
export type CurrentUser = {
  id: string;
  email: string;
  name: string | null;
  picture: string | null;
  role: string | null;
  accountId: string | null;
  status: CurrentUserStatus | null;
  isSuperUser: boolean | null;
};

export const getCurrentUser = async (): Promise<CurrentUser> => {
  const response = await axios.get<{ user: CurrentUser }>(
    `${API_ROOT}/auth/me`
  );
  return response.data.user;
};

export const getAuthErrorStatus = (error: unknown): number | undefined =>
  axios.isAxiosError(error) ? error.response?.status : undefined;
